(function () {
  var L = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var CH = { en: 'Choose colour', de: 'Farbe wählen', fr: 'Choisir la couleur', cs: 'Vyberte barvu', it: 'Scegli il colore', pl: 'Wybierz kolor' };
  var DK = { en: ['Deck', 'Cockpit'], de: ['Deck', 'Cockpit'], fr: ['Pont', 'Cockpit'], cs: ['Paluba', 'Kokpit'], it: ['Ponte', 'Pozzetto'], pl: ['Pokład', 'Kokpit'] };
  var ch = CH[L] || CH.en, dk = DK[L] || DK.en;
  var st = document.createElement('style');
  st.textContent = '#rc-colsum{display:none;margin:6px 0 10px;font-weight:700}@media(min-width:750px){#rc-colsec.rc-photo .rc-cf{display:none}#rc-colsec.rc-photo #rc-colsum{display:block}}';
  document.head.appendChild(st);
  function tick() {
    var sec = document.getElementById('rc-colsec');
    if (!sec) return;
    var d = document.getElementById('rc-sel-deck'), c = document.getElementById('rc-sel-cockpit');
    [d, c].forEach(function (s) {
      if (s && s.options[0] && s.options[0].value === '' && s.options[0].textContent !== ch) s.options[0].textContent = ch;
    });
    var photo = !!document.querySelector('.rc-zh7');
    sec.classList.toggle('rc-photo', photo);
    var sum = document.getElementById('rc-colsum');
    if (!sum) {
      var b = document.getElementById('rc-colbtn');
      if (!b) return;
      sum = document.createElement('div'); sum.id = 'rc-colsum';
      b.parentNode.insertBefore(sum, b);
    }
    var t = dk[0] + ': ' + ((d && d.value) || '–') + '  ·  ' + dk[1] + ': ' + ((c && c.value) || '–');
    if (sum.textContent !== t) sum.textContent = t;
  }
  setInterval(tick, 400);
})();

/* Steering required (v2): the template guard compares against a stale form id, so enforce it here. */
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('button');if(!b)return;
    var w=document.getElementById('rc-opts');if(!w||!w.querySelector('input[type=radio]'))return;
    var f=b.closest('form');if(!f||!f.closest('.buy-buttons-block'))return;
    var t=b.getAttribute('type');if(t&&t!=='submit')return;
    if(w.querySelector('input[type=radio]:checked'))return;
    e.preventDefault();e.stopImmediatePropagation();
    var er=w.querySelector('.rc-opts__err');if(er)er.hidden=false;
    w.scrollIntoView({block:'center',behavior:'smooth'});
  },true);
})();

/* Return to the colour step after closing the picture viewer (mobile jumped to the top). */
(function(){
  var mode=null,lastY=window.pageYOffset||0,was=false;
  function isOpen(){var lb=document.querySelector('.rc-lb');return !!lb&&!lb.hidden;}
  window.addEventListener('scroll',function(){if(!isOpen())lastY=window.pageYOffset;},{passive:true});
  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('#rc-colbtn'))mode='col';
    else if(!isOpen()&&!(e.target.closest&&e.target.closest('.rc-lb')))mode=null;
  },true);
  function go(m,y){
    if(m==='col'){
      var s=document.getElementById('rc-colsec');
      if(s){var r=s.getBoundingClientRect();window.scrollTo(0,Math.max(0,window.pageYOffset+r.top-Math.max(12,(window.innerHeight-r.height)/2)));return;}
    }
    window.scrollTo(0,y);
  }
  new MutationObserver(function(){
    var o=isOpen();
    if(o&&!was){was=true;}
    else if(!o&&was){
      was=false;var m=mode,y=lastY;mode=null;
      go(m,y);setTimeout(function(){go(m,y);},80);setTimeout(function(){go(m,y);},300);
    }
  }).observe(document.documentElement,{attributes:true,attributeFilter:['hidden'],subtree:true,childList:true});
})();

(function(){try{var s=document.createElement('style');s.textContent='.rc-opts textarea,#rc-req{color:#000 !important;-webkit-text-fill-color:#000 !important;background:#fff !important;caret-color:#000}.rc-opts textarea::placeholder,#rc-req::placeholder{color:#666 !important;-webkit-text-fill-color:#666 !important;opacity:1}';document.head.appendChild(s);}catch(e){}})();
